import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ClientDetails } from '../../Models/Models/Processes/Quote/ClientDetails';
import { RoleType } from '../../Constants/Enums/RoleType';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerNameFuzzySearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(name: string, newAccountAdviserId: number, newAccountRoleType: RoleType): Promise<Array<ClientDetails>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerNameFuzzySearch/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { name: name, newAccountAdviserId: newAccountAdviserId, newAccountRoleType: newAccountRoleType }

    return AjaxWrapper.get<Array<ClientDetails>, any>(url, data);
  }
}

